enum CollageRatioCode {
  RATIO_1x1 = '1:1',
  RATIO_2x3 = '2:3',
  RATIO_15x1 = '1.5:1',
  RATIO_18x1 = '1.8:1',
  RATIO_19x1 = '1.9:1',
}

enum CollageTemplateCode {
  DIAGONAL = 'diagonal',
  CIRCLE = 'circle',
  STRAIGHT = 'straight',
  SPLIT = 'split',
}

interface CollageTemplate {
  id: number
  name: string
  code: CollageTemplateCode
}

interface CollageRatio {
  value: number
  code: CollageRatioCode
}

interface CollageMeta {
  ratio: CollageRatio[]
  templates: CollageTemplate[]
}

export { CollageTemplateCode, CollageRatioCode }

export type { CollageTemplate, CollageRatio, CollageMeta }
